'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _resultsModule = require('./results.module.scss');

var _resultsModule2 = _interopRequireDefault(_resultsModule);

var _toolbar = require('../../toolbar');

var _toolbar2 = _interopRequireDefault(_toolbar);

var _ifeisIsomorphic = require('ifeis-isomorphic');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResultsController = function () {
  function ResultsController($document, $filter, config, fFeisService, fEventService, msgService) {
    _classCallCheck(this, ResultsController);

    this._ = { $document: $document, $filter: $filter, fFeisService: fFeisService, fEventService: fEventService, msgService: msgService };

    this.feiseanna = [];
    this.recentFeiseanna = [];
    this.selectedFeis = undefined;
    this.levels = [];
    this.selectedFeisEvents = [];
    this.selectedEvent = undefined;
    this.showFeisList = true;

    this.getCompletedFeiseanna();
  }

  // Get past feiseanna

  _createClass(ResultsController, [{
    key: 'getCompletedFeiseanna',
    value: function getCompletedFeiseanna() {
      var _this = this;

      var since = new Date().setMonth(new Date().getMonth() - 13);
      return this._.fFeisService.all({ params: { include_past: 1, since: since, is_finalized: 1 } }).then(function (results) {
        return _this.recentFeiseanna = angular.copy(results);
      }, function (err) {
        return _this._.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'findCompletedFeis',
    value: function findCompletedFeis(filter) {
      var _this2 = this;

      if (filter && this.feiseanna.length === 0) {
        return this._.fFeisService.all({ params: { include_past: 1, is_finalized: 1 } }).then(function (results) {
          _this2.feiseanna = angular.copy(results);
          return _this2.feiseanna.filter(function (f) {
            return f.feis.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
          });
        }, function (err) {
          return _this2._.msgService.displayErrorMsg(err);
        });
      }
      return this.feiseanna.filter(function (f) {
        return f.feis.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
      });
    }
  }, {
    key: 'selectFeis',
    value: function selectFeis(f) {
      var _this3 = this;

      if (f) {
        this.selectedFeis = f;

        this.evServ = this._.fEventService.for(f.feis.id);
        this.evServ.all().then(function (events) {
          // filter out events with no participants
          _this3.selectedFeisEvents = events.filter(function (e) {
            return e.participants > 0;
          }, function (err) {
            return _this3._.msgService.displayErrorMsg(err);
          });

          // upd filtered events
          _this3._syncFilteredEvents(_this3.selectedFeisEvents);
          _this3.showFeisList = false;
        });
      }
    }
  }, {
    key: 'getFeisCompletionStatus',
    value: function getFeisCompletionStatus(f) {
      var currentTimeInMills = new Date().getTime();
      if (f.dt_end > currentTimeInMills && (f.status === 'IN_PROG' || f.status === 'REG')) {
        return 'In Progress';
      } else {
        return 'Completed on ' + this._.$filter("date")(new Date(f.dt_end));
      }
    }
  }, {
    key: 'toggleEventResults',
    value: function toggleEventResults(event) {
      var _this4 = this;

      this.selectedEvent = event;
      this.evServ.placements(event.id).then(function (res) {
        _this4.selectedFeisEventsFiltered.forEach(function (ev) {
          if (ev.id === event.id) {
            ev.placements = res.filter(function (r) {
              return r.score.placed === 1;
            });
            ev.isOpen = !ev.isOpen;
          }
        });
      }, function (err) {
        return _this4._.msgService.displayErrorMsg(err);
      });
    }

    /**
     * Filter events for a selected Feis
     *
     * @param filter {String}
     * @returns {Array}
     */

  }, {
    key: 'filterEvents',
    value: function filterEvents(filter) {
      var filteredEvents = !filter ? this.selectedFeisEvents : this.selectedFeisEvents.filter(function (ev) {
        return (0, _ifeisIsomorphic.getDescription)(ev).toLowerCase().indexOf(filter.toLowerCase()) > -1;
      });
      this._syncFilteredEvents(filteredEvents);
      return filteredEvents;
    }
  }, {
    key: 'getEventName',
    value: function getEventName(event) {
      return (0, _ifeisIsomorphic.getDescription)(event);
    }
  }, {
    key: '_prepareEventsLevels',
    value: function _prepareEventsLevels() {
      var _this5 = this;

      this.levels = [];
      this.selectedFeisEventsFiltered.forEach(function (e) {

        // filter Championships and Figures
        if (e.type === 'C') {
          e.$$level = 'Championships';
        } else if (e.type === 'F') {
          e.$$level = 'Figures';
        } else {
          e.$$level = e.level;
        }

        // prepare Levels
        var levelExists = _this5.levels.find(function (l) {
          return l.level === e.$$level;
        });
        if (levelExists === undefined) _this5.levels.push({ level: e.$$level, isOpen: false });
      });
      this.levels = this._.$filter('orderBy')(this.levels, 'level');
      this.levels[0].isOpen = true;
    }
  }, {
    key: '_syncFilteredEvents',
    value: function _syncFilteredEvents(newFilteredEvents) {
      this.selectedFeisEventsFiltered = angular.copy(newFilteredEvents);
      this._prepareEventsLevels();
    }
  }]);

  return ResultsController;
}();

exports.default = angular.module('ifeis.routes.results', ['ui.router', 'ifeis.toolbar']).config(function ($stateProvider) {
  $stateProvider.state('results', {
    url: '/results',
    controller: 'ResultsController',
    controllerAs: 'res',
    template: require('./results.module.html')
  });
}).controller('ResultsController', ResultsController).filter('filterByLevel', function () {
  return function (items, level) {
    return items.filter(function (item) {
      return item.$$level === level;
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./routes/results/results.module.js
// module id = 603
// module chunks = 0